<template>
  <div class="fill-height">
    <p v-if="profileLoading" role="status">{{ $t('intake.portal.loading') }}</p>
    <div v-else-if="profileError" role="alert">
      <p>{{ $t('intake.portal.loadError') }}</p>
      <v-btn text @click="loadProfile">{{ $t('intake.bookingUi.retry') }}</v-btn>
    </div>
    <template v-else-if="profileReady">
    <v-row class="fill-height" v-if="$vuetify.breakpoint.mdAndUp">
      <v-col cols="12" lg="2">
        <div class="fill-height">
          <ConversationList/>
        </div>
      </v-col>
      <v-col cols="12" lg="10">
        <MessangerChatGPT/>
      </v-col>
    </v-row>
    <div class="" v-else>
      <v-window v-model="window">
        <v-window-item :value="0">
          <ConversationList/>
        </v-window-item>
        <v-window-item :value="1">
          <MessangerChatGPT/>
        </v-window-item>
      </v-window>
    </div>
    </template>
  </div>
</template>

<script>
/*eslint-disable*/
import DiagnosisTemplate from "@/components/ChatGpt/DiagnosisTemplate";
import MessangerChatGPT from "@/components/ChatGpt/MessangerChatGPT";
import {mapGetters} from "vuex";
import moment from "moment-jalaali";
import ConversationList from "@/components/ChatGpt/ConversationList";

export default {
  components: {ConversationList, MessangerChatGPT, DiagnosisTemplate},

  data() {
    return {
      window: 0,
      profileLoading: false,
      profileError: false,
    }
  },
  computed: {
    ...mapGetters({profile: 'getProfile'}),
    profileReady() { return !!(this.profile && typeof this.profile === 'object' && !Array.isArray(this.profile) && this.profile.id) },
  },
  methods: {
    async loadProfile() {
      if (this.profileLoading) return
      this.profileError = false
      if (this.profileReady) return
      this.profileLoading = true
      try {
        const response = await this.requesting('auth', 'getProfile')
        const profile = response && response.data && response.data.profile
        if (!response || String(response.type).toUpperCase() !== 'SUCCESS' || !profile || typeof profile !== 'object' || Array.isArray(profile) || !profile.id) throw new Error('PROFILE_UNAVAILABLE')
        if (this.profile !== profile) this.$store.commit('SET_PROFILE', {key: 'profile', data: profile})
      } catch (_) {
        this.profileError = true
      } finally {
        this.profileLoading = false
      }
    },
    syncWindowFromRoute() {
      this.window = this.$route.query.start === 'new' || this.$route.query.conversation_id ? 1 : 0
    },
  },

  mounted() {
    this.syncWindowFromRoute()
    return this.loadProfile()
  },
  watch: {
    '$route'() {
      this.syncWindowFromRoute()
    },
    '$route.query.start'() {
      this.syncWindowFromRoute()
    }
  }
}
</script>

<style scoped>

</style>
